const paths = {
  DEFAULT: "/",
  LOGIN: "/auth/login",
  DAILY_REPORTS: "/reports/daily-reports",
  WEEKLY_REPORTS: "/reports/weekly-reports",
  TASKS: "/task-management/tasks",
  PROFILE: "/settings/profile",
  RECURRENCES: "/settings/task-properties/recurrences",
  JOB_TYPES: "/settings/task-properties/job-types",
  RELATIONSHIP_STATUS: "/settings/task-properties/relationship-status",
  REQUEST_TYPES: "/settings/task-properties/request-types",
  ISSUES: "/settings/summary-properties/issues",
  SUPPORT_RESOURCES: "/settings/summary-properties/support-resources",
  REASONS: "/settings/summary-properties/reasons",
  CHALLENGES: "/settings/summary-properties/challenges",
  MY_FILES: "/documents/my-files",
  SHARED: "/documents/shared",
  VIEWER: "/documents/viewer",
  CATEGORIES: "/categories",
  GROUP_TEAMS: "/group-teams",
  MEMBER: "/member",
  DESIGN_MEMBER: "/design-member",
  TEAM_MEMBERS: "/team-members",
  USERS: "/user-management/users",
  ADD_USER: "/user-management/add-user",
  EXPORT_REPORTS: "/data/export-reports",
  CHANGE_PASSWORD: "/settings/change-password",
  UNAUTHORIZED: "/unauthorized",
  ADD_SCHEDULE_REPORT: "/data/schedule-reports/add-schedule-report",
  SCHEDULE_REPORTS: "/data/schedule-reports",
  WORK_CALENDAR: "/work-calendar",
  INCIDENTS: "/incidents",
  ADD_INCIDENT: "/add-incident",
  INCIDENTS_DASHBOARD:"/incidents-dashboard",
  ADD_COURSE: "/add-course",
  COURSES: "/courses",
  COURSES_USER: "/courses-user",
  ADD_CUSTOMER: "/add-customer",
  CUSTOMERS: "/customers",
  ADD_JD: "/add-jd",
  JDS: "/jds",
  ADD_CANDIDATE: '/add-candidate',
  CANDIDATES: '/candidates'
};

export default paths;
